import { apiCall } from 'src/utils/ApiCall';

// Temporary interfaces until TypeScript client is updated
export interface CreateExportInput {
  controlId: string;
  exportName: string;
  filters?: Record<string, string[]>;
}

export interface CreateExportOutput {
  status: string;
  message: string;
}

export const createOpenPOExport = async (input: CreateExportInput): Promise<CreateExportOutput> => {
  const body: any = {
    exportName: input.exportName,
  };

  // Add filters if provided
  if (input.filters) {
    body.filters = JSON.stringify(input.filters);
  }

  const response = await apiCall({
    endpoint: `/CreateExport/${input.controlId.toUpperCase()}`,
    method: 'POST',
    body,
  });

  return response as CreateExportOutput;
};
